const firebaseConfig = {
  apiKey: "AIzaSyAZtnzAf4Uwt-UHEHYpeK3oXrIYM-i0fDU",
  authDomain: "cryptogeek-9f5ca.firebaseapp.com",
  projectId: "cryptogeek-9f5ca",
  storageBucket: "cryptogeek-9f5ca.appspot.com",
  messagingSenderId: "549146244709",
  appId: "1:549146244709:web:0fd8fa8f924a2d456c788c"
};

export default firebaseConfig;